import React, { useContext } from 'react';
import { Box, Button, FormGroup, IconButton, Paper, styled, Typography } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';

import { CartContext } from '../CartContext'
import { calculateFamilyAndKidDiscountAmount } from 'shared';
import { AddCircleOutline, AddCircleRounded, RemoveCircleOutline } from '@mui/icons-material';

const QuantityControl = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #e0e0e0',
  borderRadius: 24,
  padding: theme.spacing(0.5),
}));


function ProductCard({ product }) {
  const cart = useContext(CartContext)
  const productQuantity = cart.getProductQuantity(product.id)
  // const productPrice = productQuantity * (product.price - (cart.getProductDiscountAmount(product.id)));

  const newPrice = (product?.price ?? 0) - calculateFamilyAndKidDiscountAmount(product.title, cart.items);
  
  return (
    <Paper elevation={1} sx={{ maxWidth: 400, mx: 'auto', p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Box>
      <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', fontSize: '16px' }}>
      {product.title}
      </Typography>

 
      <Typography variant="body1" sx={{ fontWeight: 'bold', mt: 1 }}>
        {newPrice && newPrice !== product?.price ? 
          <>
            <span style={{textDecoration: 'line-through', color: '#808080'}}>{product.price}$</span>
            <span style={{marginLeft: '10px'}}>{newPrice}$</span>
          </>
          : product.price + '$'
        }
      </Typography>
    </Box>
    <QuantityControl>
      <IconButton  onClick={() => cart.removeOneFromCart(product.id)} color="primary">
        <RemoveCircleOutline />
      </IconButton>
      <Typography sx={{ mx: 2 }}>{productQuantity}</Typography>
      <IconButton  onClick={() => cart.addOneToCart(product)}  color="primary">
        <AddCircleOutline />
      </IconButton>
    </QuantityControl>
  </Paper>
    // <div className='ticket'>     
    //   <ListItemText primary={renderProductText()} />
    //   <FormGroup row>
    //     <Button size="small" sx={{ marginRight: '10px', minWidth: '35px !important', height: '35px' }} variant="outlined" onClick={() => cart.removeOneFromCart(product.id)}  >-</Button>
    //     <ListItemText variant="outlined" sx={{ maxWidth: '25px', textAlign: 'center' }}>{productQuantity}</ListItemText>
    //     <Button size="small" variant="outlined" onClick={() => cart.addOneToCart(product)} sx={{ marginLeft: '10px', minWidth: '35px !important', height: '35px' }} >+</Button>
    //     <Typography sx={{ marginLeft: '10px', marginRight: '5px', fontWeight: 'bold', width: ' 30px' }}>{productQuantity ? productPrice + '$' : ' '}</Typography>
    //   </FormGroup>
    // </div>
  );
}



export default ProductCard;
